import { Box, Grid, Paper, Typography } from "@mui/material";
import { estrapolaData } from "../../functions/utils";


export const EsitiLayout = (esiti) => {
    const esitiMock = {
        "esiti": [
            {
                "screeningTypeCode": "CL",
                "screeningTypeDesc": "Campagna di Screening per il colon retto",
                "invitationDate": "2020-10-30T00:00:00.000Z",
                "resultType": "NEG"
            },
            {
                "screeningTypeCode": "CL",
                "screeningTypeDesc": "Screening mammografico",
                "invitationDate": "2020-10-30T00:00:00.000Z",
                "resultType": "NEG"
            }
        ]
    }
    return (
        <>
            <Box className={esiti?.esiti?.length > 0 ? "bg" : "bgEmpty"}
                sx={{
                    overflow: 'hidden',
                    width: "100%",
                }}>
                <Box sx={{ x: 'auto' }}>
                    <Grid container wrap="nowrap" spacing={2}>
                        <Grid item xs zeroMinWidth>

                            <Box sx={{ width: "100%", height: "150px", display: "flex", minWidth: "180px", }}>
                                <Typography
                                    component='h1'
                                    sx={{
                                        color: "#005397",
                                        margin: "auto",
                                        textAlign: "center",
                                        fontSize: { xs: "25px", md: "40px" },
                                        fontWeight: 700,
                                    }}
                                >
                                    Consulta gli esiti delle campagne di screening
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{ my: 0, mx: 'auto' }}>
                    <Grid container spacing={2}>
                        <Grid item xs>
                            <Box
                                sx={{
                                    width: { xs: "90%", sm: '65%', md: "60%", lg: '50%' },
                                    margin: "auto",
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                {
                                    esiti?.esiti?.length > 0 ?
                                        esiti?.esiti?.map((element, index) =>
                                            <EsitiPaper element={element} index={index} />
                                        )
                                        :
                                        <Box >
                                            <Box
                                                sx={{
                                                    minHeight: "300px",
                                                    width: "100%",
                                                    display: "flex",
                                                    margin: "auto",
                                                    flexDirection: "column",
                                                    backgroundColor: "transparent ",
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: "#005397",
                                                        fontSize: { xs: "30px", md: "45px" },
                                                        fontWeight: 700,
                                                        margin: "auto",
                                                        textAlign: "center",
                                                        width: "60%",
                                                        wordWrap: "inherit" /* {xs: 'none', md: 'break-word'} */,
                                                    }}
                                                >
                                                    Non sono ancora presenti gli esiti dei tuoi screening
                                                </Typography>
                                            </Box>
                                        </Box>
                                }
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </>
    );
}

const EsitiPaper = ({ element, index }) => {
    return (
        <Paper className="esito" key={index} elevation={5} sx={{ backgroundColor: 'white', borderRadius: '20px', margin: 'auto', display: 'flex', flexDirection: 'column', padding: '15px', gap: '5px', marginBottom: '15px', width: '100%' }}>
            <Typography component='h2' sx={{ color: '#005397', fontSize: '25px', textAlign: 'center', fontWeight: 700 }}>
                {element.screeningTypeDesc}
            </Typography>
            <Typography sx={{ color: '#005397', fontSize: '20px', textAlign: 'center', fontWeight: 500 }}>
                Esame del {estrapolaData(element?.invitationDate)}
            </Typography>
            <Typography sx={{ color: '#005397', fontSize: '20px', textAlign: 'center', fontWeight: 600 }}>
                Esito {element.resultType === 'NEG' && 'NEGATIVO'}
            </Typography>
        </Paper>
    );
}